<script setup lang="ts">
import { ref } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import FormSkeleton from '@apparatix/Components/FormSkeleton.vue';
import { AeLimit, AeLimitResponse } from '@apparatix/types/Account';
import { useEndpoint } from '@apparatix/composables';

const aeLimit = ref<AeLimit[]>();

const {
  isLoading, makeRequest: makeAeLimitRequest,
} = useEndpoint<AeLimitResponse>({
  url: '/crm/accounts/limits',
  type: 'GET',
  successField: 'data',
  startInLoadingState: true,
  onSuccess: response => {
    aeLimit.value = response.data.aeLimits;
  },
  toast: { showOnSuccess: false },
});

makeAeLimitRequest();

const isProspectCountGreater = (row) => row.prospectCount > row.prospectLimit;
const isAdvertiserCountGreater = (row) => row.advertiserCount > row.advertiserLimit;
const isTotalCountGreater = (row) => row.totalCount > row.totalLimit;
</script>

<template>
  <FormSkeleton v-if="isLoading" />
  <template v-else>
    <DataTable
      :value="aeLimit"
      filter-display="row"
      :virtual-scroller-options="{itemSize: 50}"
      responsive-layout="scroll"
      data-key="userId"
    >
      <Column field="userName" header="User" sortable />
      <Column
        field="prospectCount"
        header="Prospect Count"
        sortable
      >
        <template #body="{ data }">
          <span :class="{ 'text-red-600': isProspectCountGreater(data) }">
            {{ data.prospectCount }} / {{ data.prospectLimit }}
          </span>
        </template>
      </Column>
      <Column
        field="advertiserCount"
        header="Advertiser Count"
        sortable
      >
        <template #body="{ data }">
          <span :class="{ 'text-red-600': isAdvertiserCountGreater(data) }">
            {{ data.advertiserCount }} / {{ data.advertiserLimit }}
          </span>
        </template>
      </Column>
      <Column
        field="totalCount"
        header="Total Count"
        sortable
      >
        <template #body="{ data }">
          <span :class="{ 'text-red-600': isTotalCountGreater(data) }">
            {{ data.totalCount }} / {{ data.totalLimit }}
          </span>
        </template>
      </Column>
    </DataTable>
  </template>
</template>
